/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelLink64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelLink64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M44 39H21V38H44V39Z" fill="currentColor" />
            <path
              d="M22.9355 33.1016H26.8232V34H21.9229V25.6367H22.9355V33.1016Z"
              fill="currentColor"
            />
            <path
              d="M29.2246 34H28.2607V27.7275H29.2246V34Z"
              fill="currentColor"
            />
            <path
              d="M33.832 27.6455C34.2567 27.6455 34.6287 27.733 34.9473 27.9072C35.2657 28.0787 35.5135 28.3403 35.6904 28.6914C35.8673 29.0398 35.9561 29.4812 35.9561 30.0146V34H34.9922V30.0791C34.9921 29.5865 34.8642 29.2026 34.6084 28.9277C34.3525 28.6501 34.0011 28.5117 33.5547 28.5117C33.247 28.5117 32.9718 28.5785 32.7295 28.7119C32.49 28.8453 32.3009 29.0401 32.1621 29.2959C32.0234 29.5518 31.9541 29.8619 31.9541 30.2266V34H30.9902V27.7275H31.9209V28.707H32.0029C32.1499 28.3887 32.3735 28.1327 32.6729 27.9395C32.9722 27.7436 33.3586 27.6455 33.832 27.6455Z"
              fill="currentColor"
            />
            <path
              d="M38.6807 30.5205H38.7949L41.5391 27.7275H42.7314L40.0811 30.4062L42.9277 34H41.7031L39.3555 31.0264L38.6807 31.6514V34H37.7168V25.6367H38.6807V30.5205Z"
              fill="currentColor"
            />
            <path
              d="M28.751 25.375C28.9388 25.375 29.099 25.4394 29.2324 25.5674C29.3685 25.6953 29.4375 25.8487 29.4375 26.0283C29.4375 26.208 29.3685 26.3623 29.2324 26.4902C29.0991 26.6179 28.9386 26.6816 28.751 26.6816C28.5631 26.6816 28.4008 26.6182 28.2646 26.4902C28.1312 26.3623 28.0645 26.208 28.0645 26.0283C28.0645 25.8489 28.1315 25.6952 28.2646 25.5674C28.4008 25.4394 28.5631 25.375 28.751 25.375Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelLink64Icon.tags = ['link', 'add', 'connect', 'hyperlink', 'attach'];

AddPanelLink64Icon.category = '64x64 (Add panel)';

AddPanelLink64Icon.iconSize = 64;
